module.exports = __webpack_public_path__ + "assets/screen-9295d2.svg";